import { AppState } from 'reducers';
import { MigrationStatus } from 'reducers/migration';

export const getMigrationStatus = (state: AppState): MigrationStatus => state.migration.status;
